import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthContext";
import { fetchProfile } from "../api/user";
import { PASS_TYPE_LABELS } from "../constants/passTypes";

const LOCATION_LINE = {
  bay_area: "Bay Area crew",
  sacramento: "Sacramento crew",
  tahoe_local: "Tahoe local",
};

export function HomeTab({ onSignIn }) {
  const { user } = useAuth();
  const { data: profile } = useQuery({
    queryKey: ["profile", user?.userId],
    queryFn: () => fetchProfile(user.userId),
    enabled: !!user?.userId,
  });

  const homeLocation = profile?.homeLocation;
  const passType = profile?.passType && profile.passType !== "none" ? profile.passType : null;

  return (
    <section className="glass">
      <h1>
        Pow<span className="accent">Horizon</span>
      </h1>
      {homeLocation ? (
        <p>
          {LOCATION_LINE[homeLocation]}
          {passType ? `, on the ${PASS_TYPE_LABELS[passType]}` : ""} — Conditions is sorted to your resorts
          first{homeLocation === "tahoe_local" ? "; skip Traffic and Lodging, you're already up here." : "."}
        </p>
      ) : (
        <p>
          Is this Saturday worth the drive to Tahoe? Conditions, chain control, carpool, and lodging — in one
          place, built for Bay Area and Sacramento locals.
        </p>
      )}
      <p className="sec-dek">
        {homeLocation
          ? "Set or change your home base and pass any time from your profile."
          : "Set your home base and season pass in your profile to personalize this."}
      </p>
      {onSignIn && (
        <button className="btn-accent" onClick={onSignIn}>
          Sign in / sign up
        </button>
      )}
    </section>
  );
}
